import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="support-request"
export default class extends Controller {
  static targets = ['modal', 'ulid'];

  async connect() {}

  async generateCode() {
    try {
      // Show loading state
      if (this.hasUlidTarget) {
        this.ulidTarget.textContent = 'Wird generiert...';
      }

      // Generate ULID via AJAX
      const response = await fetch('/staff/support_requests', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        }
      });

      if (response.ok) {
        const data = await response.json();
        if (this.hasUlidTarget) {
          this.ulidTarget.textContent = data.ulid;
        }
      } else {
        throw new Error('Failed to generate support code');
      }
    } catch (error) {
      console.error('Error generating support code:', error);
      if (this.hasUlidTarget) {
        this.ulidTarget.textContent = 'Fehler beim Generieren';
      }
    }
  }
}
